(function(window, angular, undefined) {
    'use strict';

    var m = angular.module('vvCommon', ['ng', 'ngSanitize', 'xdLocalStorage', 'oc.lazyLoad']);

    m.config(['$provide', function($provide) {
        $provide.decorator('$rootScope', ['$delegate', '$injector', function($delegate, $injector) {
            $delegate.$onScope = function($scope, name, listener) {
                var offFn = $delegate.$on(name, listener);
                $scope.$on('$destroy', function() {
                    offFn();
                });
            };
            Object.getPrototypeOf($delegate).$interval = function(fn, delay, count, invokeApply, Pass) {
                var $interval = $injector.get('$interval');
                var promise = $interval(fn, delay, count, invokeApply, Pass);
                this.$on('$destroy', function() {
                    $interval.cancel(promise);
                });
            };
            Object.getPrototypeOf($delegate).$timeout = function(fn, delay, invokeApply, Pass) {
                var $timeout = $injector.get('$timeout');
                var promise = $timeout(fn, delay, invokeApply, Pass);
                this.$on('$destroy', function() {
                    $timeout.cancel(promise);
                });
            };
            return $delegate;
        }]);
        $provide.decorator('inputDirective', function($delegate) {
            var directive = $delegate[0];
            angular.extend(directive.link, {
                post: function(scope, element, attr, ctrls) {
                    element.on('compositionupdate', function(event) {
                        element.triggerHandler('compositionend');
                    })
                }
            });
            return $delegate;
        });
    }]);

    m.factory('staticInterceptor', function($log, vv) {
        var interceptor = {};

        var staticRoot = vv.getVvMetaData('static_root');
        console.log(staticRoot);
        if (staticRoot) {
            interceptor.request = function(config) {
                if (!config.url.toLowerCase().match(/^https?:\/\//i)) {
                    if (config.url.lastIndexOf('/m/', 0) === 0 || config.url.indexOf('?_hv=') >= 0)
                        config.url = staticRoot + config.url;
                }

                return config;
            };
        }

        return interceptor;
    });

    m.run(function($window, $rootScope, vv) {
        if ($window.$) {
            // DEPRECATED
            $window.$.cachedScript = function(url, callback) {
                $window.$.ajax({
                    type: 'GET',
                    url: url,
                    success: callback,
                    dataType: 'script',
                    cache: true
                });
            };
        }

        if (vv.feature.splitResultPageHostname) {
            $rootScope.$on('$locationChangeStart', function(event, newUrl, oldUrl) {
                var parsedNewUrl = vv.parseUrl(newUrl);
                var path = parsedNewUrl.pathname;
                var isResultPage = path.indexOf('/quiz/r/') == 0;
                if (isResultPage && !vv.isSubDomain) {
                    event.preventDefault();
                    $window.location = vv.addDomainPrefixOnUrlIfNecessary(newUrl);
                } else if (!isResultPage && vv.isSubDomain) {
                    event.preventDefault();
                    $window.location = vv.removeDomainPrefixOnUrl(newUrl);
                }
            });
        }

        // Recommend Banner Test
        if (Math.random()*100 <= 10) {
            window.recommendBanner = true
        } else {
            window.recommendBanner = false
        }
    });

    m.constant('vvBrowser', vvBrowser);
    m.constant('vvUtils', vvUtils);
    m.constant('vvCommon', vvCommon);
    m.constant('vvGa', vvGa);
    m.constant('vvTrack', vvTrack);

    m.constant('vv', new function() {
        var vv = this;

        vv.getCdnRoot = function() {
            return vv.getVvMetaData('cdn_root');
        };

        vv.getCdnUrl = function(path) {
            return vv.getCdnRoot() + (path || "");
        };

        vv.safeString = function(s) {
            return window.vv.safeString(s);
        };

        vv.getOrigin = function(location) {
            return window.vv.getOrigin(location);
        };

        vv.getShareOrigin = function(location) {
            var shareOriginDomain = vv.getVvMetaData("share_origin_domain");
            if (!shareOriginDomain) {
                return vv.getCdnRoot();
            }
            if (location == null) {
                location = window.location;
            }
            return location.protocol + '//' + shareOriginDomain + (location.port ? ':' + location.port : '');
        };

        vv.getImageAPIHost = function() {
            var envSn = vv.getEnvSn();
            if (envSn === 'dev' || envSn === 'beta') {
                return 'https://imgapi-dev.vonvon.me';
            }
            return 'https://imgapi.vonvon.me';
        };

        vv.getImageAPIUrl = function(path) {
            var hostAndPath = vv.getImageAPIHost() + path;
            var vvOrigin = '_vv_origin=' + encodeURIComponent(window.vv.getOrigin());
            var query = (hostAndPath.indexOf('?') === -1 ? '?' : '&') + vvOrigin;
            return hostAndPath + query;
        };

        vv.getPath = function(location) {
            if (location == null)
                location = window.location;

            return location.pathname + location.search + location.hash;
        };

        vv.$ = function(selectorOrElement) {
            if (typeof selectorOrElement == 'string' || selectorOrElement instanceof String)
                return angular.element(window.document.querySelectorAll(selectorOrElement));
            else
                return angular.element(selectorOrElement);
        };

        vv.$find = function(element, selector) {
            var results = [];
            angular.forEach(element, function(e) {
                results = angular.extend(results, e.querySelectorAll(selector));
            });
            return angular.element(results);
        };

        vv.getWindowWidth = function() {
            return window.document.documentElement.clientWidth;
        };

        vv.getWindowHeight = function() {
            return window.document.documentElement.clientHeight;
        };

        vv.buildSearch = function(params) {
            return window.vv.buildSearch(params);
        };

        vv.parseQuery = function(query) {
            return window.vv.parseQuery(query);
        };

        vv.removeAllChildren = function(node) {
            while (node.lastChild) {
                node.removeChild(node.lastChild);
            }
        };

        vv.getHashCode = function(str) {
            var hash = 0, i, chr, len;
            if (str.length == 0) return hash;
            for (i = 0, len = str.length; i < len; i++) {
                chr   = str.charCodeAt(i);
                hash  = ((hash << 5) - hash) + chr;
                hash |= 0; // Convert to 32bit integer
            }
            return hash;
        };

        vv.getMetaData = function(name) {
            return window.vv.getMetaData(name);
        };

        vv.setMetaData = function(name, value) {
            return window.vv.setMetaData(name, value);
        };

        vv.getVvMetaData = function(name) {
            return window.vv.getVvMetaData(name);
        };

        vv.setVvMetaData = function(name, value) {
            return window.vv.setVvMetaData(name, value);
        };

        vv.removeSearchParam = function (url, key) {
            var result = url.split("?")[0],
                value = "",
                queryString = (url.indexOf("?") !== -1) ? url.split("?")[1] : "";
            if (queryString !== "") {
                var params_arr = queryString.split("&");
                for (var i = params_arr.length - 1; i >= 0; i -= 1) {
                    var key_equals = key + '=';
                    if (params_arr[i].indexOf(key_equals) === 0) {
                        value = decodeURIComponent(params_arr[i].substring(key_equals.length));
                        params_arr.splice(i, 1);
                    }
                }
                result = result + "?" + params_arr.join("&");
            }
            return [result, value];
        };

        vv.appendSearch = function(search, params) {
            if (search)
                return search + '&' + vv.buildSearch(params);
            else
                return '?' + vv.buildSearch(params);
        };

        vv.appendSearchToPath = function(path, params) {
            return window.vv.appendSearchToPath(path, params);
        };

        vv.parseUrl = function(url) {
            return window.vv.parseUrl(url);
        };

        vv.parseSearch = function(search) {
            return window.vv.parseSearch(search);
        };

        vv.uuidv4 = function() {
            return window.vv.uuidv4();
        };

        var _replaceSearchParam = function(s, k, v) {
            var r = new RegExp('\\b'+k+'=[^&]*');
            var kv = k + '=' + encodeURIComponent(v);
            if (s.search(r) < 0) {
                if (s.length > 0) {
                    return s+'&'+kv;
                } else {
                    return '?'+kv;
                }
            } else {
                return s.replace(r, kv);
            }
        };

        var _replaceSearchParams = function(s, dict) {
            for (var k in dict) {
                s = _replaceSearchParam(s, k, dict[k]);
            }
            return s;
        };

        vv.replaceUrlParams = function(url, params) {
            var parser = vv.parseUrl(url);
            parser.search = _replaceSearchParams(parser.search, params);
            return parser.href;
        };

        vv.rot13 = function(str) {
          return (str + '').replace(/[a-z]/gi, function (s) {
            return String.fromCharCode(s.charCodeAt(0) + (s.toLowerCase() < 'n' ? 13 : -13))
          })
        };

        vv.resizedImageUrl = function(url, s, pixelRatio, q) {
            s = s || 0;
            q = q || 65;
            pixelRatio = pixelRatio || window.devicePixelRatio || 1;
            s = Math.round(s * pixelRatio);
            var parser = vv.parseUrl(url);
            if (parser.hostname.search(/\.(ggpht|googleusercontent)\.com$/) >= 0) {
                return url.replace(/((=|%3D)s\d+(-l\d+)?)?$/, '=s'+s+'-l'+q).replace(/^http:\/\//i, '//');
            } else if (parser.hostname == window.location.hostname &&
                (parser.pathname.indexOf('/api/image/') == 0 || parser.pathname.indexOf('/api/i/') == 0 || parser.pathname.indexOf('/api/bi/') == 0)) {
                if (parser.pathname.match(/^\/api\/i\/\d+\/0\/intro$/) != null) {
                    parser.hostname = vv.parseUrl(vv.getImageAPIHost()).hostname;
                    parser.port = 443;
                    parser.search = _replaceSearchParams(parser.search, {_vv_origin: window.vv.getOrigin()});
                } else {
                    parser.hostname = vv.parseUrl(vv.getCdnRoot()).hostname;
                }
                parser.search = _replaceSearchParams(parser.search, {s: s, q: q});
                return parser.href;
            } else if (parser.hostname == 'cdn-cn.vonvon.net' && parser.pathname.indexOf('.gif', parser.pathname.length - 4) == -1) {
                var resizedUrl = url.replace('cdn-cn.vonvon.net', 'cn-image.vonvon.net') + '@'+s+'w_'+s+'h_0e';
                if (url.indexOf('.png', url.length - 4) !== -1) {
                    resizedUrl += '.png';
                }
                return resizedUrl;
            } else {
                return url;
            }
        };

        vv.adjustProtocol = function(url) {
            return url.replace(/^http:\/\//i, '//');
        };

        vv.buildRedirectShortenPopupUrl = function(origin, path, params, redirect_param) {
            var location = vv.buildUrl(origin, path, params);
            return vv.buildVonvonUrl('/redirect/shorten', angular.extend(redirect_param, {
                location: location
            }));
        };

        vv.getRankingHost = function() {
            var stage = vv.getVvMetaData('stage');

            if (stage == 'real')
                return 'ranking.vonvon.me';
            else if (stage == 'dev')
                return 'ranking.' + stage + '.vonvon.me:5000';
            else
                return 'ranking.' + stage + '.vonvon.me';
        };

        vv.buildRankingApiUrl = function(path, params) {
            var url = window.location.protocol + '//' + vv.getRankingHost() + '/api' + (path != null ? path : '/');
            var search = vv.buildSearch(params);

            if (search)
                return url + '?' + search;
            else
                return url;
        };

        vv.buildUrl = function(origin, path, params) {
            var url = origin + (path != null ? path : '');
            var search = vv.buildSearch(params);

            if (search)
                return url + '?' + search;
            else
                return url;
        };

        vv.buildVonvonUrl = function(path, params) {
            return vv.buildUrl(vv.getOrigin(), path, params);
        };

        vv.getNormalizedOrigin = function() {
            var stage = vv.getVvMetaData('stage');

            var domain = (function() {
                var region = vv.getVvMetaData('region');
                var scat = vv.getVvMetaData('scat');

                var baseDomain = (function() {
                    if (scat == 'wooof')
                        return 'wooof.me';
                    else if (region == 'cn' && stage != 'dev' && stage != 'beta')
                        return 'vonvon.net';
                    else
                        return 'vonvon.me';
                })();

                if (stage != 'real')
                    baseDomain = stage + '.' + baseDomain;

                if (scat == 'vonvon')
                    return region + '.' + baseDomain;
                else
                    return baseDomain;
            })();

            if (stage == 'dev')
                return 'http://' + domain + ':8080';
            else
                return 'http://' + domain;
        };

        vv.buildNormalizedVonvonUrl = function(path, params) {
            var origin = vv.getNormalizedOrigin();
            return vv.buildUrl(origin, path, params);
        };

        vv.getSnsCallbackUrl = function(sns, path, params) {
            if (path == null)
                return vv.buildVonvonUrl('/callback/' + sns, params);
            if (path[0] != '/')
                path = '/' + path;
            return vv.buildVonvonUrl('/callback/' + sns + path, params);
        };

        vv.getHomeUrl = function() {
            return vv.buildVonvonUrl('/');
        };

        vv.getQuizUrl = function(quiz_id, params) {
            return vv.buildVonvonUrl('/quiz/' + quiz_id, params);
        };

        vv.getQuizQuestionUrl = function(quiz_id, question_id, ext, params) {
            if (ext.mq_id != null) {
                var url = '/mequiz/' + quiz_id + '/n/' + ext.mq_id + '/q/' + question_id;
                if (ext.hasOwnProperty('fq'))
                    url = url + '/' + ext.fq;

                return vv.buildVonvonUrl(url, params);
            } else {
                return vv.buildVonvonUrl('/quiz/' + quiz_id + '/q/' + question_id, params);
            }
        };

        vv.getFbQuizUrl = function(quiz_id, params) {
            if (params && params.mq_id) {
                return vv.buildNormalizedVonvonUrl('/quiz/'+quiz_id+'/n/'+params.mq_id);
                //return vv.buildNormalizedVonvonUrl('/mequiz/'+quiz_id+'/n/'+params.mq_id);
            } else {
                return vv.buildNormalizedVonvonUrl('/quiz/' + quiz_id, params);
            }
        };

        vv.getSharePopupUrl = function(shareName, data) {
            return vv.buildVonvonUrl('/popup/share/' + shareName + '/' + urlbase64.encodeJson(data));
        };

        var generateRnd = function(count) {
            var rnd = '';
            var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            for (var i = 0; i < count; i++)
                rnd += possible.charAt(Math.floor(Math.random() * possible.length));
            return rnd;
        };

        vv.getQuizResultUrl = function(quiz_id, meaning_id, ext, params) {
            if (ext.fr != null) {
                if (ext.mq_id) {
                    return vv.buildVonvonUrl('/mequiz/r/' + quiz_id + '/n/' + ext.mq_id + '/' + meaning_id + '/' + ext.fr, params);
                } else if (ext.tm_id) {
                    return vv.buildVonvonUrl('/tellme/r/' + quiz_id + '/n/' + ext.tm_id+ '/' + meaning_id + '/' + ext.fr, params);
                }
                return vv.buildVonvonUrl('/quiz/r/' + quiz_id + '/' + meaning_id + '/' + ext.fr, params);
            }
            if (ext.gameScore != null)
                return vv.buildVonvonUrl('/quiz/rg/' + quiz_id + '/' + meaning_id + '/' + ext.gameScore, params);
            if (ext.fb_id != null && ext.r != null)
                params = angular.extend({fb_id: ext.fb_id, r: ext.r}, params);
            return vv.buildVonvonUrl('/quiz/result/' + quiz_id + '/' + meaning_id, params);
        };

        vv.getSiblingQuizUrl = function(url, siblingRegion, siblingQuizId, originInfo) {
            var region = vv.getVvMetaData('region');
            var re = '(^.*[\/|\.])' + region + '(\..*\/quiz\/)[0-9]+(.*$)';
            re = new RegExp(re);
            var siblingUrl = url.replace(re, '$1' + siblingRegion + '$2' + siblingQuizId + '$3');
            siblingUrl = siblingUrl.replace('_vv_org=' + originInfo, '_vv_org=back-' + region);
            siblingUrl = siblingUrl.replace('_vv_sbl=' + siblingRegion + '-' + siblingQuizId, '');
            siblingUrl = siblingUrl.replace(/([\?|\&])\&/g, '$1');
            siblingUrl = siblingUrl.replace(/[\?|\&]$/, '');

            return siblingUrl;
        };

        vv.changeDomainOnUrl = function(link, domain) {
            if (!domain) {
                return link;
            }
            var parser = vv.parseUrl(link);
            parser.hostname = domain;
            return parser.href;
        };

        vv.addDomainPrefixOnUrlIfNecessary = function(link) {
            // 도메인 찢기 제외 국가 지정
            if (vv.inRegions(['cn'])) {
                return link;
            }

            if (vv.getVvMetaData('host_region') == 'uk') {
                return link;
            }

            var m = link.match(/\/quiz\/(?:rg?\/)?(\d+)/);
            if (m == null || m.length < 2) {
                return link;
            }

            var quiz_id = m[1];
            var hvalues = vv.getVvMetaData('hvalues');
            console.log('hvalues', hvalues.length);
            var codes = hvalues[(quiz_id * quiz_id * 29 % 929) % hvalues.length]
                + hvalues[(quiz_id * quiz_id * 101 % 571) % hvalues.length]
                + hvalues[(quiz_id * quiz_id * 677 % 761) % hvalues.length];

            var host_pat = vv.getVvMetaData('host_pat').replace(/##/, '');
            var pos = link.indexOf(host_pat);
            if (pos < 0)
                return link;

            // https 제외
            if (link.toLowerCase().indexOf('https://') == 0)
                return link;

            link = link.substr(0, pos).replace(
                /^(https?:\/\/)(?:\d+\.|n-[^.]+\.)?((?:\w\w))/, '$1n-' + codes + '.$2'
            ) + link.substr(pos);

            return link;
        };

        vv.removeDomainPrefixOnUrl = function(link) {
            return link.replace(/:\/\/[nN]-[^.]+\./i, '://');
        };

        vv.getShareIntroCountPath = function(quiz_id, where, buttonName) {
            return vv.buildVonvonUrl('/api/share/' + quiz_id + '/' + where, { btn: buttonName, grt_origin: vvTrack.getCampaign().origin });
        };

        vv.getShareIntroBridgePath = function(quiz_id, where) {
            return '/share/quiz/' + quiz_id + '/' + where;
        };

        vv.getShareResultCountPath = function(quiz_id, meaning_id, link, where, buttonName) {
            var path = '/api/share/' + quiz_id + '/' + meaning_id + '/' + where;
            if (link)
                path += '/' + Math.abs(vv.getHashCode(link));
            return vv.buildVonvonUrl(path, { btn: buttonName, grt_origin: vvTrack.getCampaign().origin });
        };

        vv.getShareQuestionCountPath = function(quiz_id, question_id, link, where, buttonName) {
            var path = '/api/share/question/' + quiz_id + '/' + question_id + '/' + where;
            if (link)
                path += '/' + Math.abs(vv.getHashCode(link));
            return vv.buildVonvonUrl(path, { btn: buttonName, grt_origin: vvTrack.getCampaign().origin });
        };

        vv.getShareResultBridgePath = function(quiz_id, meaning_id, link, where) {
            var path = '/share/quiz/' + quiz_id + '/' + meaning_id + '/' + where;
            if (link)
                path += '/' + Math.abs(vv.getHashCode(link));
            return path;
        };

        vv.getShareQuestionBridgePath = function(quiz_id, question_id, link, where) {
            var path = '/share/question/' + quiz_id + '/' + question_id+ '/' + where;
            if (link)
                path += '/' + Math.abs(vv.getHashCode(link));
            return path;
        };

        vv.inRegions = function(regions) {
            return (regions.indexOf(vv.getVvMetaData('region')) != -1);
        };

        vv.getRegion = function() {
            return vv.getVvMetaData('region');
        };

        vv.getServiceName = function() {
            return vv.getVvMetaData('service_name');
        }

        vv.getEnvSn = function() {
            return vv.getVvMetaData('env_sn');
        }

        vv.getFbPageUrl = function() {
            var publisher = vv.getMetaData('article:publisher');
            if (!publisher) {
                publisher = 'https://www.facebook.com/vonvon.me';
            }
            return publisher;
        };

        vv.getTwtAccount = function() {
            return (vv.getVvMetaData('tw') || '').replace(/^@/, '');
        };

        vv.getLineFollowUrl = function(region, is2nd) {
            if (region == 'jp')
                return (!is2nd) ? 'https://line.me/R/ti/p/%40vonvon' : 'https://line.me/R/ti/p/%40pzj5790i';
            else if (region == 'th')
                return 'https://line.me/R/ti/p/%40vonvon_th';
            else if (region == 'id')
                return 'https://line.me/R/ti/p/%40vonvon_id';
            else if (region == 'tw')
                return 'https://line.me/R/ti/p/%40vonvon_tw';
        };

        vv.getLineFollowImageUrl = function(region) {
            if (region == 'jp')
                return 'http://biz.line.naver.jp/line_business/img/btn/addfriends_ja.png';
            else if (region == 'th')
                return 'http://biz.line.naver.jp/line_business/img/btn/addfriends_en.png';
            else if (region == 'id')
                return 'http://biz.line.naver.jp/line_business/img/btn/addfriends_en.png';
            else if (region == 'tw')
                return 'http://biz.line.naver.jp/line_business/img/btn/addfriends_zh-Hant.png';
        };

        vv.feature = {
            showFriendResult: vv.inRegions(['cn']),
            disableDelayedLoad: vv.inRegions(['cn']),
            splitResultPageHostname: false
        };

        vv.urlbase64 = urlbase64;

        var fb_to_short_map = 'QVg56xqO0rhC8b2sKnXNIjFtBwkYJlaL-9Mzmvdi7SDfHuopT4GZWAyeER1cPU3';
        vv.getShortId = function(fb_id) {
            var shortIds = [];
            for (var i = fb_id.length - 1; i >= 0; i--) {
                var c = fb_id.charCodeAt(i);
                if (c >= '0'.charCodeAt(0) && c <= '9'.charCodeAt(0))
                    shortIds.push(fb_to_short_map.charAt(c - '0'.charCodeAt(0)));
                else if (c >= 'A'.charCodeAt(0) && c <= 'Z'.charCodeAt(0))
                    shortIds.push(fb_to_short_map.charAt(c - 'A'.charCodeAt(0) + 10));
                else if (c >= 'a'.charCodeAt(0) && c <= 'z'.charCodeAt(0))
                    shortIds.push(fb_to_short_map.charAt(c - 'a'.charCodeAt(0) + 36));
                else if (c == ':'.charCodeAt(0))
                    shortIds.push(fb_to_short_map.charAt(62));
                else
                    shortIds.push(fb_id.charAt(i));
            }

            return shortIds.join('');
        };

        vv.binbase64 = {
            encode: function(buffer) {
                var binary = '';
                var bytes = new Uint8Array(buffer);
                var len = bytes.byteLength;
                for (var i = 0; i < len; i++) {
                    binary += String.fromCharCode(bytes[i]);
                }
                return btoa(binary);
            },

            decode: function(base64) {
                var binary_string =  atob(base64);
                var len = binary_string.length;
                var bytes = new Uint8Array( len );
                for (var i = 0; i < len; i++) {
                    bytes[i] = binary_string.charCodeAt(i);
                }
                return bytes.buffer;
            }
        };

        vv.isSubDomain = (function(vv) {
            var host_pat = vv.getVvMetaData('host_pat');
            return host_pat && host_pat.indexOf('##') > 0;
        })(this);

        var _importedScripts = {};
        var $q = angular.injector(['ng']).get('$q');
        var importOneScript = function(url, opts) {
            opts = angular.extend({
                async: false
            }, opts);

            if (url[0] == '/' && url[1] != '/') {
                var staticRoot = vv.getVvMetaData('static_root');
                url = staticRoot + url;
            }
            if (url in _importedScripts) {
                console.log('already imported', url)
                return _importedScripts[url];
            }

            var deferredImport = $q.defer();
            _importedScripts[url] = deferredImport.promise;

            var s = document.createElement('script'); // use global document since Angular's $document is weak
            s.src = url;
            var done = false;
            s.onload = function() {
                if (!done) {
                    deferredImport.resolve();
                    done = true;
                    console.log('loaded', url);
                }
            };
            s.onerror = function() {
                if (!done) {
                    deferredImport.reject();
                    done = true;
                }
            };
            s.onreadystatechange = function() {
                if (!done) {
                    var state = s.readyState;
                    if (state == 'complete') {
                        deferredImport.resolve();
                    } else if (state != 'loading' && state != 'interactive') { // 이게 맞는 건지 테스트 필요
                        deferredImport.reject();
                    }
                    console.log('loaded', url);
                    done = true;
                }
            };
            if (opts.async || true)
                s.async = 1;
            document.body.appendChild(s);

            return deferredImport.promise;
        };

        vv.shuffle = function(obj) {
            var j, x, i;
            var len = obj.length;

            if (len < 2)
                return obj;

            for(j,x,i = len; i; j = Math.floor(Math.random() * i), x = obj[--i], obj[i] = obj[j], obj[j] = x);

            return obj;
        };

        vv.getKoreanSuffix = function(word, suffix) {
            var code = word.charCodeAt(word.length-1) - 44032;

            // 원본 문구가 없을때는 빈 문자열 반환
            if (word.length == 0) return '';

            var last_word = word.slice(-1);

            if (code % 28 == 0 || ['a', 'e', 'i', 'o', 'u', 'y'].indexOf(last_word) > -1) return word + this.getSuffix(suffix, false);
            else return word + this.getSuffix(suffix, true);
        };

        vv.getSuffix = function(suffix, last_sound) {
            // last_sound : true면 받침있음, false면 받침없음

            if (suffix == '을' || suffix == '를') return (last_sound ? '을' : '를');
            if (suffix == '이' || suffix == '가') return (last_sound ? '이' : '가');
            if (suffix == '은' || suffix == '는') return (last_sound ? '은' : '는');
            if (suffix == '와' || suffix == '과') return (last_sound ? '과' : '와');
            if (suffix == '랑' || suffix == '이랑') return (last_sound ? '이랑' : '랑');

            // 알 수 없는 조사
            return suffix;
        };

        var jsModules = vv.getVvMetaData('js_modules');
        var importScriptModule = function(module, opts) {
            if (jsModules && module in jsModules) {
                var moduleFiles = jsModules[module];
                console.log('import script module', module, moduleFiles);
                if (moduleFiles.length == 1) {
                    return importOneScript(moduleFiles[0], opts);
                }

                var promise = null;
                angular.forEach(moduleFiles, function(module) {
                    if (promise)
                        promise = promise.then(function() { return importOneScript(module, opts)})
                    else
                        promise = importOneScript(module, opts)
                });
                return $q.when(promise)
            }

            console.log('import script module', module);
            return importOneScript(module, opts);
        };

        vv.importScriptInSerial = function(scriptList, opts) {
            var promise = null;
            scriptList.forEach(function(script) {
                if (promise)
                    promise = promise.then(function() { return vv.importScript(script, opts) });
                else
                    promise = vv.importScript(script, opts);
            });
            return $q.when(promise);
        };

        // import scripts in parallel
        // importScripts(['a', 'b']);
        // importScripts(['a', 'b'], {serial: true});
        // importScripts(['a', 'b', {files: ['c', 'd'], opts: {force: true}}, ['e', 'f']]);
        vv.importScript = function(scripts, opts) {
            if (!(scripts instanceof Array)) {
                return importScriptModule(scripts, opts);
            }

            if (opts.serial) {
                return vv.importScriptInSerial(scripts, opts);
            }

            var promises = [];
            scripts.forEach(function(e) {
                if (e instanceof Array) {
                    promises.push(vv.importScriptInSerial(e, opts));
                } else if (e instanceof Object) {
                    var lOpts = {};
                    angular.extend(lOpts, opts);
                    angular.extend(lOpts, e.opts);
                    promises.push(vv.importScriptInSerial(e.files, lOpts));
                } else {
                    promises.push(importScriptModule(e, opts));
                }
            });
            return $q.all(promises);
        };

        vv.range = function (start, end) {
            var list = [];
            var asc = start < end;
            if (asc == true) {
                for (var i = start; i <= end; i++)
                    list.push(i);
            } else {
                for (var i = start; i >= end; i--)
                    list.push(i);
            }
            return list;
        };

        vv.isSpaceChar = function(char) {
            if (char == ' ' || char == '\r' || char == '\n' || char == '\t')
                return true;
            else
                return false;
        };

        vv.truncateByUrlEncodedLength = function(string, lengthLimit, breakWord, noEllipsis) {
            string = string.trim();
            var suffixLength = noEllipsis ? 0 : 3;

            var encodedString = encodeURIComponent(string);
            if (encodedString.length <= lengthLimit)
                return string;

            var truncatedString = function() {
                encodedString = encodedString.substr(0, lengthLimit - suffixLength);
                while (true) {
                    try {
                        var decodedString = decodeURIComponent(encodedString).trim();
                        // 단어를 잘라도 되므로 바로 리턴
                        if (breakWord)
                            return decodedString;

                        // 단어의 끝이므로 바로 리턴
                        if (vv.isSpaceChar(string.charAt(decodedString.length)))
                            return decodedString;

                        for (var i = decodedString.length - 2; i >= 0; i--) {
                            if (vv.isSpaceChar(decodedString.charAt(i)))
                                return decodedString.substr(0, i).trim();
                        }

                        return decodedString;
                    } catch (e) {
                        encodedString = encodedString.substr(0, encodedString.length - 1);
                    }
                }
            }();

            if (noEllipsis)
                return truncatedString;
            else
                return truncatedString + '...';
        };

        vv.watchState = function(state, saved, keys) {
            for (var i = 0; i < keys.length; i++) {
                if (saved == null || state[keys[i]] != saved[keys[i]]) {
                    var newState = {};
                    for (var j = 0; j < keys.length; j++) {
                        newState[keys[j]] = state[keys[j]];
                    }
                    return newState;
                }
            }
            return saved;
        };

        vv.hex2Rgb = function(hex) {
            var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
            return result ? {
                r: parseInt(result[1], 16),
                g: parseInt(result[2], 16),
                b: parseInt(result[3], 16)
            } : null;
        };

        vv.getSnsUserProfile = function(key, user_inputs) {
            if (key.indexOf('snsfriend_') == 0 && user_inputs.hasOwnProperty('choice_sns_friends') && user_inputs['choice_sns_friends'].hasOwnProperty(key))
                return user_inputs['choice_sns_friends'][key];
            else if (key.indexOf('ipfriend_') == 0 && user_inputs.hasOwnProperty('choice_ip_friends') && user_inputs['choice_ip_friends'].hasOwnProperty(key))
                return user_inputs['choice_ip_friends'][key];
            else if ((key == 'user_profile' || key == 'profile') && user_inputs.hasOwnProperty('user_profile'))
                return user_inputs['user_profile'];

            return {};
        };

        vv.getSnsImageInfo = function(key, user_inputs) {
            if (user_inputs.hasOwnProperty('choice_sns_images') && user_inputs['choice_sns_images'].hasOwnProperty(key))
                return user_inputs['choice_sns_images'][key];

            return {};
        }

        vv.getWhoamiUrl = function() {
            var valid_service_map = {
                en: 'en',
                br: 'pt',
                es: 'es',
                fr: 'fr',
                it: 'it',
                de: 'de',
                th: 'th',
                ph: 'tl',
                id: 'id',
                tw: 'tw',
                kr: 'ko',
                jp: 'ja',
                my: 'ms',
                nl: 'nl',
                tr: 'tr'
            };

            var region = vv.getVvMetaData('host_region');
            var default_language = 'en';
            var language = default_language;

            for (var key in valid_service_map) {
                if (region == key) {
                    language = valid_service_map[key];
                }
            }

            var stage = vv.getVvMetaData('stage');
            if (stage == 'beta') {
                return 'https://whoami-beta.vonvon.me/' + language + '/q/1';
            } else { // dev 환경을 whoami랑 같이 띄울 수 없어서 그냥 real url로.
                return 'https://whoami.vonvon.me/' + language + '/q/1';
            }
        }
    });





    m.constant('vvCookies', vvCookies);
    m.constant('vvSessionStorage', vvSessionStorage);
    m.constant('vvSessionUtils', vvSessionUtils);















    m.filter('capitalize', function() {
        return function(input, scope) {
            if (!input)
                return input;
            return input.substring(0,1).toUpperCase() + input.substring(1);
        }
    });

    m.filter('ifEmpty', function() {
        return function(input, defaultValue) {
            if (angular.isUndefined(input) || input === null || input === '') {
                return defaultValue;
            }
            return input;
        }
    });

    m.filter('reverse', function () {
        return function (items) {
            if (items == null)
                return items;
            return items.slice().reverse();
        };
    });

    m.filter('wordBreak', function() {
        return function(text) {
            text = text.replace(/(([_.,:;/?=#-]|%[0-9]+)+)/g, '$1<wbr>');
            var openTag = '<span style="white-space: nowrap">';
            var closeTag = '</span>';
            return openTag + text.replace(/((\s|<wbr>)+)/g, closeTag + '$1' + openTag) + closeTag;
        };
    });
    
    m.value('vvSupportRegion', [
        { code: 'en', name:'English' },
        { code: 'la', name:'Español' },
        { code: 'br', name:'Português' },
        { code: 'fr', name:'Français' },
        { code: 'de', name:'Deutsch' },
        { code: 'it', name:'Italiano'},
        { code: 'kr', name:'한국어' },
        { code: 'cn', name:'中文（简体）' },
        { code: 'tw', name:'中文（正體)' },
        { code: 'jp', name:'日本語' },
        { code: 'th', name:'ภาษาไทย' },
        { code: 'vn', name:'Tiếng Việt' },
        { code: 'my', name:'B. Malaysia' },
        { code: 'id', name:'B. Indonesia' },
        { code: 'nl', name:'Nederlands' },
        { code: 'fi', name:'Suomi', closed:true },
        { code: 'tr', name:'Türkçe' },
        { code: 'se', name:'Svenska', closed:true },
        { code: 'dk', name:'Dansk', closed:true },
        { code: 'no', name:'Norsk', closed:true },
        { code: 'ph', name:'Filipino' },
        { code: 'ru', name:'Русский' },
    ]);

    m.value('vvPartnerList', {
        'indosat' : {
            key: 'indosat',
            path: '/indosatooredoo',
            name: 'indosat',
            region: 'id',
            list_title_img : 'indosat/list_title.jpg',
            access_deny_type: 'alert',
            access_deny_msg: 'Program VONVON spesial ini hanya berlaku untuk pelanggan Indosat Ooredoo.\nYuk pakai kartu Indosat sekarang!'
        },
       'spesial' : {
            key: 'spesial',
            path: '/p/spesial',
            name: 'spesial',
            region: 'id',
            list_title_img: 'spesial/list_title.jpg',
            access_deny_type: 'alert',
            access_deny_msg: 'Program VONVON spesial ini hanya berlaku untuk pelanggan XL atau Axis.\nYuk pakai kartu XL atau Axis sekarang!'
        },
        'smartfren' : {
            key: 'smartfren',
            path: '/p/smartfren',
            name: 'smartfren',
            region: 'id',
            //list_title_img: 'spesial/list_title.jpg', // spotlight banner 사용
            access_deny_type: 'url',
            access_deny_msg : 'Maaf, Layanan ini hanya bisa diakses oleh Pelanggan Android Smartfren melalui aplikasi.\nSilahkan download aplikasi VONVON di page berikut ini.',
            redirect_url: 'http://vonvon.hpheboh.com/nonsubs/'
        }
    });
})(window, window.angular);

require("./vonvon-common/directives/when-scrolled")
require("./vonvon-common/directives/when-body-scrolled")
require("./vonvon-common/directives/activity-indicator")
require("./vonvon-common/directives/bind-html-compile")
require("./vonvon-common/directives/center-align")
require("./vonvon-common/directives/center-layer")
require("./vonvon-common/directives/center-nodim-layer")
require("./vonvon-common/directives/select-on-click")
require("./vonvon-common/directives/vv-after")
require("./vonvon-common/directives/vv-audio-src")
require("./vonvon-common/directives/vv-delayed-load")
require("./vonvon-common/directives/vv-delayed-src")
require("./vonvon-common/directives/vv-error-layer")
require("./vonvon-common/directives/vv-game-static-src")
require("./vonvon-common/directives/vv-if-shown")
require("./vonvon-common/directives/vv-lazy-compile")
require("./vonvon-common/directives/vv-linky-word-break")
require("./vonvon-common/directives/vv-on-visible-bind")
require("./vonvon-common/directives/vv-popup-layer")
require("./vonvon-common/directives/vv-scaled-background-image")
require("./vonvon-common/directives/vv-scaled-src")
require("./vonvon-common/directives/vv-speech-bubble")
require("./vonvon-common/directives/vv-static-src")
require("./vonvon-common/directives/vv-word-break")
require("./vonvon-common/directives/white-dialog")
require("./vonvon-common/directives/ng-src")

require("./vonvon-common/controllers/footer-ctrl")
require("./vonvon-common/controllers/header-ctrl")
require("./vonvon-common/controllers/privacy-policy-ctrl")

require("./vonvon-common/services/m")
require("./vonvon-common/services/vv-ab-test")
require("./vonvon-common/services/vv-dimension")
require("./vonvon-common/services/vv-face-detection")
require("./vonvon-common/services/vv-inflow-quiz-ids")
require("./vonvon-common/services/vv-local-storage")
require("./vonvon-common/services/vv-monitor-share-status")
require("./vonvon-common/services/vv-page")
require("./vonvon-common/services/vv-popup")
require("./vonvon-common/services/vv-service")
require("./vonvon-common/services/vv-taken-quiz-ids")
require("./vonvon-common/services/vv-recommended-quiz-ids")
require("./vonvon-common/services/vv-register")
